import React, { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { ContextProvider } from "../Context/SharedStateContext";
import log1 from "../assets/img/Login-image.png";
import log2 from "../assets/img/login-img-2.png";
import log3 from "../assets/img/login-security.png";
import log4 from "../assets/img/Review Manage.png";
import "./registerStyle.css";
import { Spinner } from "react-bootstrap";

// Social login icons (consider using react-icons instead of image files)
import { FaGoogle, FaFacebook, FaLinkedin, FaGithub } from "react-icons/fa";

const RegisterPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    productSelected,
    setProductSelected,
    planTypeSelected,
    setPlanSelected,
    planSelected,
    setPlanTypeSelected,
  } = useContext(ContextProvider);

  // State management
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    url: "",
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [accessToken, setAccessToken] = useState("");
  const [hostShop, setHostShop] = useState("");
  const [readUrl, setReadUrl] = useState(false);
  const [readEmail, setReadEmail] = useState(false);
  const userFrom = sessionStorage.getItem("userFrom");
  const [chatLoading, setChatLoading] = useState(true); // State for loading

  // Images for carousel
  const images = [
    { src: log1, alt: "Customer review" },
    { src: log2, alt: "Chat interface" },
    { src: log3, alt: "Login Security" },
    { src: log4, alt: "Review Manage" },
  ];

  // Fetch shopify data on component mount
  useEffect(() => {
    fetchShopifyData();
  }, []);

  const fetchShopifyData = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const shopUrl = urlParams.get("shop");
      const encodedState = urlParams.get("state");

      const localShopUrl = localStorage.getItem("shopURL") || shopUrl;
      const localShop = localStorage.getItem("shopURL");
      const tenantName = localStorage.getItem("tenantName");
      const headers = {
        "Content-Type": "application/json",
        "x-shop-url": localShopUrl,
      };
      if (shopUrl) {
        // Handle Shopify integration logic
        sessionStorage.setItem("userFrom", "shopify");

        if (
          localShop &&
          tenantName !== null &&
          tenantName !== "" &&
          tenantName
        ) {
          const accessTokenResponse = await axios.get(
            `${process.env.REACT_APP_CHAT_BACKEND_URL}/api/accessToken`,
            { headers }
          );
          const accessToken = accessTokenResponse.data;
          // console.log("accessToken", accessToken);

          if (accessToken.message === "New") {
            const api = await axios.get(
              `${process.env.REACT_APP_CHAT_BACKEND_URL}/install?shop=${shopUrl}`
            );
            // console.log(api);
            window.location.href = api.data;
          } else {
            navigate(`/${tenantName}/chat/dashboard`);
          }
        }
      }

      if (encodedState) {
        try {
          const decodedState = JSON.parse(atob(encodedState));
          const { primedomain, accessToken, hostShop } = decodedState;

          const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/clientinfo`,
            {
              params: {
                storeUrl: primedomain,
                product: "popup",
              },
            }
          );
          const clientData = response.data;
          // console.log(clientData.tentant_info);
          if (clientData.tentant_info) {
            setReadEmail(true);
            setFormData((prev) => ({
              ...prev,
              email: clientData.tentant_info.tenant_email,
            }));
          }
          setReadUrl(true);
          setFormData((prev) => ({ ...prev, url: primedomain }));
          setProductSelected("Chat");
          setPlanSelected("free");
          setPlanTypeSelected("month");
          localStorage.setItem("shopURL", primedomain);
          setAccessToken(accessToken);
          setHostShop(hostShop);
        } catch (error) {
          console.error("Invalid state data:", error);
        }
      } else if (!localShop && shopUrl) {
        const api = await axios.get(
          `${process.env.REACT_APP_CHAT_BACKEND_URL}/install?shop=${shopUrl}`
        );
        // console.log(api);
        window.location.href = api.data;
      }
    } catch (err) {
      console.error("Error processing shopify data", err);
      Swal.fire({
        icon: "error",
        title: "Connection Error",
        text: "Failed to connect with Shopify. Please try again.",
      });
    } finally {
      setChatLoading(false); // Stop loading after data fetch
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Clear error when user types
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const urlRegex =
      /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;

    if (!formData.name.trim()) newErrors.name = "Full name is required";
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email";
    }
    if (!formData.url) {
      newErrors.url = "Store URL is required";
    } else if (!urlRegex.test(formData.url)) {
      newErrors.url = "Please enter a valid URL";
    }
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters";
    }
    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/register`,
        {
          inputvalue: formData,
          date: new Date().toISOString().split("T")[0],
          registerdata: {
            product: productSelected,
            plan_name: planSelected,
            plan_type: planTypeSelected,
          },
          accessToken,
          hostShop,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "$2a$12$tXgoc0t8Pfva7LmlyQ6/aOtB//vaEWOcdV3ElI82pAlevLYSLeg6W",
          },
        }
      );

      if (response.status === 200) {
        const tName = response.data.registeredData.tenant_name;
        const stateData = {
          tenant_name: tName,
          tenantDB: response.data?.registeredData?.tenant_database,
        };

        Swal.fire({
          icon: "success",
          title: response.data.message || "Registration Success!",
          showConfirmButton: false,
          timer: 1500,
        });

        navigate(
          `/${tName}/products?state=${encodeURIComponent(
            JSON.stringify(stateData)
          )}`
        );
      } else if (response.status === 202) {
        Swal.fire({
          icon: "info",
          title: response.data.message || "User Exists!",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        throw new Error(response.data.message || "Registration failed");
      }
    } catch (error) {
      console.error("Registration error:", error);
      Swal.fire({
        icon: "error",
        title: "Registration Failed",
        text: error.response?.data?.message || "Please try again later",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSocialLogin = async (provider) => {
    try {
      const { data: authUrl } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/social-login/${provider}`,
        {
          registerdata: {
            product: productSelected,
            plan_name: planSelected,
            plan_type: planTypeSelected,
          },
        }
      );
      window.location.href = authUrl;
    } catch (err) {
      console.error("Social login error:", err);
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: "Could not connect to the social provider. Please try again.",
      });
    }
  };

  return (
    <div className="register-container">
      {chatLoading ? (
        <div
          style={{
            height: "100vh",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#f0f1f6",
          }}
        >
          <Spinner
            animation="border"
            variant="primary"
            style={{ width: "3rem", height: "3rem" }}
          />
        </div>
      ) : (
        <>
          {/* Left Side - Carousel */}
          <div className="register-carousel">
            <div className="carousel-slide">
              <img
                src={images[currentImageIndex].src}
                alt={images[currentImageIndex].alt}
              />
            </div>
            <div className="carousel-dots">
              {images.map((_, index) => (
                <button
                  key={index}
                  className={`dot ${
                    index === currentImageIndex ? "active" : ""
                  }`}
                  onClick={() => setCurrentImageIndex(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>

          {/* Right Side - Form */}
          <div className="register-form-container">
            <div className="form-header">
              <h2>Get Started With EPIC-X</h2>
              <p>Create your account in just a few simple steps</p>

              {!userFrom && (
                <>
                  <div className="social-login-buttons">
                    <button
                      onClick={() => handleSocialLogin("google")}
                      aria-label="Sign up with Google"
                    >
                      <FaGoogle /> Google
                    </button>
                    <button
                      onClick={() => handleSocialLogin("facebook")}
                      aria-label="Sign up with Facebook"
                    >
                      <FaFacebook /> Facebook
                    </button>
                    <button
                      onClick={() => handleSocialLogin("linkedin")}
                      aria-label="Sign up with LinkedIn"
                    >
                      <FaLinkedin /> LinkedIn
                    </button>
                    <button
                      onClick={() => handleSocialLogin("github")}
                      aria-label="Sign up with GitHub"
                    >
                      <FaGithub /> GitHub
                    </button>
                  </div>
                  <div className="divider">
                    <span>OR</span>
                  </div>
                </>
              )}
            </div>

            <form onSubmit={handleSubmit} className="registration-form">
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className={errors.name ? "error" : ""}
                  placeholder="John Doe"
                />
                {errors.name && (
                  <span className="error-message">{errors.name}</span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className={errors.email ? "error" : ""}
                  placeholder="your@email.com"
                  readOnly={readEmail}
                />
                {errors.email && (
                  <span className="error-message">{errors.email}</span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="url">Store URL</label>
                <input
                  type="text"
                  id="url"
                  name="url"
                  value={formData.url}
                  onChange={handleInputChange}
                  className={errors.url ? "error" : ""}
                  placeholder="yourstore.com"
                  readOnly={readUrl}
                />
                {errors.url && (
                  <span className="error-message">{errors.url}</span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <div className="password-input">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    className={errors.password ? "error" : ""}
                    placeholder="At least 8 characters"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="toggle-password"
                    aria-label={
                      showPassword ? "Hide password" : "Show password"
                    }
                  >
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                  </button>
                </div>
                {errors.password && (
                  <span className="error-message">{errors.password}</span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="confirmPassword">Confirm Password</label>
                <div className="password-input">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    id="confirmPassword"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleInputChange}
                    className={errors.confirmPassword ? "error" : ""}
                    placeholder="Confirm your password"
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className="toggle-password"
                    aria-label={
                      showConfirmPassword ? "Hide password" : "Show password"
                    }
                  >
                    <FontAwesomeIcon
                      icon={showConfirmPassword ? faEyeSlash : faEye}
                    />
                  </button>
                </div>
                {errors.confirmPassword && (
                  <span className="error-message">
                    {errors.confirmPassword}
                  </span>
                )}
              </div>

              <button
                type="submit"
                className="submit-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <span className="spinner"></span> Creating Account...
                  </>
                ) : (
                  "Create Account"
                )}
              </button>
            </form>

            <div className="form-footer">
              <p>
                Already have an account?{" "}
                <Link to="/login" className="login-link">
                  Sign in
                </Link>
              </p>
              <p className="terms">
                By continuing, you agree to our{" "}
                <a href="/terms">Terms of Service</a> and{" "}
                <a href="/privacy">Privacy Policy</a>.
              </p>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default RegisterPage;
